<template>
  <ca-row>
    <ca-col :size="selectColSizeMixin">
      <stocking-select
        ref="stockingSelect"
        v-model="stockId"
        placeholder="Selecione"
        required
        :refresh-form="refreshForm"></stocking-select>
    </ca-col>

    <ca-col
      v-if="shouldShowAddButtonMixin"
      size="4"
      class="ca-u-margin-top">
      <ca-button full-width @click="openCreateStockingsModal">Nova lotação</ca-button>
    </ca-col>
  </ca-row>
</template>

<script>
import CreateStockingsModal from '../../modals/CreateStockingsModal';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';

export default {
  name: 'WorkerStockingSelect',
  mixins: [workerFormMixin],
  props: {
    value: String,
    refreshForm: Function,
  },
  data() {
    return {
      stockId: this.value,
    };
  },
  watch: {
    stockId(value) {
      this.onInputChange(value);
    },
  },
  methods: {
    onInputChange(value) {
      this.$emit('change', value);
      this.$emit('input', value);
    },
    openCreateStockingsModal() {
      this.$dialogModal(CreateStockingsModal, {
        on: {
          created: () => this.$refs.stockingSelect.getStockings(),
        },
      }).open();
    },
  },
};
</script>
